import { ReactElement } from 'react';

import { createSingleInterpolatedTranslationKey, createTranslatedText } from '@dreryk/react-common';
import { Chip, ChipVariant, Tooltip } from '@dreryk/react-components';

import { ICD10Code } from '../../../../shared/types';
import { medicineSelectorTranslationKeys } from '../../../../translations';

type MedicineSelectActionInputChipProps = {
   readonly icd10Code: ICD10Code;
   readonly onClick: (icd10Code: ICD10Code) => void;
   readonly icon: ReactElement;
   readonly selected: boolean;
};

export const MedicineSelectorActionInputChip = (props: MedicineSelectActionInputChipProps): ReactElement => {
   return (
      <Tooltip
         testId={props.icd10Code}
         content={createSingleInterpolatedTranslationKey(
            medicineSelectorTranslationKeys.searchMedicinesRelatedToIcd10Code,
            'icd10Code',
            props.icd10Code
         )}
      >
         <Chip
            testId={props.icd10Code}
            label={createTranslatedText(props.icd10Code)}
            variant={props.selected ? ChipVariant.FILLED : ChipVariant.OUTLINED}
            onClick={() => {
               props.onClick(props.icd10Code);
            }}
            icon={props.icon}
         />
      </Tooltip>
   );
};
